import React from "react";
import { FormGroup, FormControl, ControlLabel} from 'react-bootstrap';

export default class FormField extends React.Component {

    renderOptions(data) {
        let options = data.map(function (item, index) {
            return (
                <option value={item.key} key={index}>{item.value}</option>
            )
        });

        return (options);
    }

    render() {
        if (this.props.type === "text") {
            return (
                <FormGroup>
                    <ControlLabel>{this.props.title}</ControlLabel>
                    <FormControl defaultValue={this.props.value} name={this.props.name} readOnly={this.props.readOnly ? this.props.readOnly : false} onChange={this.props.onChange} autoComplete={"off"} />
                </FormGroup>
            )
        } else if (this.props.type === "password") {
            return (
                <FormGroup>
                    <ControlLabel>{this.props.title}</ControlLabel>
                    <input type="password" style={{display: "none"}} name="password" />
                    <FormControl type="password" 
                        defaultValue={this.props.value} 
                        name={this.props.name} 
                        readOnly={this.props.readOnly ? this.props.readOnly : false} 
                        onChange={this.props.onChange} 
                        autoComplete={false}
                         />
                </FormGroup>
            )
        } else if (this.props.type === "select") {
            return (
                <FormGroup>
                    <ControlLabel>{this.props.title}</ControlLabel>
                    <FormControl componentClass="select" name={this.props.name} defaultValue={this.props.value} onChange={this.props.onChange} autoComplete={"off"}>
                        <option value={0}>Vyberte</option>
                        {this.renderOptions(this.props.options)}
                    </FormControl>
                </FormGroup>
            )
        } else if(this.props.type === "hidden") {
            return <input type="hidden" name={this.props.name} defaultValue={this.props.value} />
        }
    }
}


// WEBPACK FOOTER //
// ./src/modules/base/FormField.js